__turbopack_context__.v({
  "className": "akkuratll_4a6c5e9-module__J9Dghq__className",
  "variable": "akkuratll_4a6c5e9-module__J9Dghq__variable",
});
